import { render, staticRenderFns } from "./WineUpdate.vue?vue&type=template&id=0cccca3c"
import script from "./WineUpdate.vue?vue&type=script&lang=ts"
export * from "./WineUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports